/** What happened to the post: it was on screen, or the user opened it */
export type ContentEventType = 'Impression' | 'Open';

/** Where the post was on screen */
export type ContentSurface = 'Feed' | 'Profile' | 'CompanyCard' | 'Community' | 'Room' | 'Boardroom';

export interface ContentEvent {
  contentId: UUID;
  type: ContentEventType;
  surface: ContentSurface;
}

export const MAX_CONTENT_EVENTS_PER_REQUEST = 50;
